/**
 * Module dependencies.
 */

/**
 * Export `Award` type.
 */

export type Award = {
  date: string;
  imageUrl: string;
  title: string;
};

/**
 * Export `awards`.
 */

export const awards: Award[] = [
  {
    date: 'Germany, 2024',
    imageUrl: '/static/images/awards/german-innovation-award-2024@2x.jpg',
    title: 'German Innovation Award'
  },
  {
    date: 'Germany, 2024',
    imageUrl: '/static/images/awards/if-design-award-2024@2x.jpg',
    title: 'IF Design Award'
  },
  {
    date: 'Chicago, 2023',
    imageUrl: '/static/images/awards/good-design-award-2019@2x.jpg',
    title: 'Good Design Award'
  },
  {
    date: 'Australia, 2021',
    imageUrl: '/static/images/awards/good-design-australia-2021@2x.jpg',
    title: 'Good Design Australia'
  },
  {
    date: 'USA, 2019',
    imageUrl: '/static/images/awards/green-good-design-award-2018@2x.jpg',
    title: 'Green Good Design Award'
  },
  {
    date: 'Germany, 2019',
    imageUrl: '/static/images/awards/if-design-award-2019@2x.jpg',
    title: 'IF Design Award'
  },
  {
    date: 'USA, 2018',
    imageUrl: '/static/images/awards/good-design-award-2019@2x.jpg',
    title: 'Good Design Award'
  },
  {
    date: 'Germany, 2017',
    imageUrl: '/static/images/awards/if-design-award-2017@2x.jpg',
    title: 'IF Design Award'
  },
  {
    date: 'Germany, 2017',
    imageUrl: '/static/images/awards/red-dot-design-award-2017@2x.jpg',
    title: 'Red Dot'
  },
  {
    date: 'Germany, 2012',
    imageUrl: '/static/images/awards/if-design-award-gold-2012@2x.jpg',
    title: 'IF Design Award GOLD'
  },
  {
    date: 'Germany, 2012',
    imageUrl: '/static/images/awards/if-design-award-2012@2x.jpg',
    title: 'IF Design Award'
  },
  {
    date: 'USA, 2010',
    imageUrl: '/static/images/awards/idea-silver-prize-2010@2x.jpg',
    title: 'IDSA Silver Prize'
  },
  {
    date: 'Spain, 2009',
    imageUrl: '/static/images/awards/delta-awards-2009@2x.jpg',
    title: 'Delta Award'
  },
  {
    date: 'Australia, 2009',
    imageUrl: '/static/images/awards/good-design-australia-2009@2x.jpg',
    title: 'Good Design Australia'
  },
  {
    date: 'Germany, 2008',
    imageUrl: '/static/images/awards/german-design-award-2008@2x.jpg',
    title: 'German Design Award'
  },
  {
    date: 'Germany, 2007',
    imageUrl: '/static/images/awards/if-design-award-gold-2007@2x.jpg',
    title: 'IF Design Award GOLD'
  },
  {
    date: 'Germany, 2007',
    imageUrl: '/static/images/awards/if-design-award-2007@2x.jpg',
    title: 'IF Design Award'
  },
  {
    date: 'Germany, 2007',
    imageUrl: '/static/images/awards/red-dot-2007@2x.jpg',
    title: 'Red Dot'
  },
  {
    date: 'Japan, 2006',
    imageUrl: '/static/images/awards/good-design-2006@2x.jpg',
    title: 'Good Design Award'
  },
  {
    date: 'USA, 2006',
    imageUrl: '/static/images/awards/idea-2006@2x.jpg',
    title: 'IDSA'
  },
  {
    date: 'France, 2005',
    imageUrl: '/static/images/awards/jec-2005@2x.jpg',
    title: 'JEC - "Spirit of Conquest" Special Jury Award'
  }
];
